export default {
  metaInfo: {
    title: "아이디 찾기",
  },
  data() {
    return {
      setList: [],
    };
  },
  mounted() {},
  computed: {
    idList() {
      this.setList = this.$store.state.account.idList;
      return this.setList;
    },
  },
  created() {},
  methods: {
    moveToBack() {
      this.$store.dispatch("account/initializationUserInfo");
      this.$store.dispatch("account/deleteUserIdList");
      this.$router.replace("/users/find-account");
    },
    moveToSignIn() {
      this.$store.dispatch("account/initializationUserInfo");
      this.$store.dispatch("account/deleteUserIdList");
      this.$router.replace("/users/signin");
    },
  },
};
